module.exports = __webpack_public_path__ + "static/sailRankshome2-0c7c0fc4048229b4c526e09464b9d257.png";